// Configuration management for the webapp
// All environment variables should be accessed through this module

interface Config {
  api: {
    baseUrl: string;
    wsBaseUrl: string;
  };
  map: {
    tileServerUrl: string;
  };
  features: {
    enableDebug: boolean;
    enableInterpolation: boolean;
    enablePastTracks: boolean; // Enable fetching of past track history
    defaultDelaySeconds: number;
    performanceMode: boolean; // Enable for low-end devices
    maxPilotsForSmooth: number; // Threshold for switching to simple interpolation
  };
  defaults: {
    raceId: string;
    raceName: string;
  };
  auth: {
    adminToken: string;
  };
  env: 'development' | 'production' | 'test';
}

const config: Config = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
    wsBaseUrl: process.env.REACT_APP_WS_BASE_URL || 'ws://localhost:8000',
  },
  map: {
    tileServerUrl: process.env.REACT_APP_TILE_SERVER_URL || 'http://localhost:8080',
  },
  features: {
    enableDebug: process.env.REACT_APP_ENABLE_DEBUG === 'true',
    enableInterpolation: process.env.REACT_APP_ENABLE_INTERPOLATION !== 'false',
    enablePastTracks: process.env.REACT_APP_ENABLE_PAST_TRACKS !== 'false',
    defaultDelaySeconds: parseInt(process.env.REACT_APP_DEFAULT_DELAY_SECONDS || '60', 10),
    performanceMode: process.env.REACT_APP_PERFORMANCE_MODE === 'true',
    maxPilotsForSmooth: parseInt(process.env.REACT_APP_MAX_PILOTS_SMOOTH || '20', 10),
  },
  defaults: {
    raceId: process.env.REACT_APP_DEFAULT_RACE_ID || '68aadbb85da525060edaaebf',
    raceName: process.env.REACT_APP_DEFAULT_RACE_NAME || 'HFSS App Testing',
  },
  auth: {
    adminToken: process.env.REACT_APP_ADMIN_TOKEN || '',
  },
  env: (process.env.REACT_APP_ENV as 'development' | 'production' | 'test') || 'development',
};

// Helper functions
export const isDevelopment = () => config.env === 'development';
export const isProduction = () => config.env === 'production';

// API URL builders
export const getApiUrl = (path: string) => {
  const baseUrl = config.api.baseUrl.replace(/\/$/, ''); // Remove trailing slash
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

export const getWsUrl = (path: string) => {
  const baseUrl = config.api.wsBaseUrl.replace(/\/$/, ''); // Remove trailing slash
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

// Debug logging
export const debugLog = (...args: any[]) => {
  if (config.features.enableDebug) {
    console.log('[DEBUG]', ...args);
  }
};

export default config;